import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BusinessUnits, Customers, Facilities } from 'src/app/model/customer';
import { SortByPipe } from 'src/app/pipes/sort-by.pipe';
import { CommonService } from 'src/app/services/common.service';
import { IsLoadingService } from 'src/app/services/loading.service';
import { PaginationSortingService } from 'src/app/services/paginationsorting.service';
import { PrinterConfigService } from 'src/app/services/printer-config.service';

@Component({
  selector: 'app-print-requestor',
  templateUrl: './print-requestor.component.html',
  styleUrls: ['./print-requestor.component.scss']
})
export class PrintRequestorComponent implements OnInit {



  /** Event Emitters */
  @Output() closePopUpModal = new EventEmitter<any>();
  @Output() printRequestor = new EventEmitter<any>();

  searchPopupFormGroup: FormGroup;
  customers: Customers;
  businessUnit: BusinessUnits;
  facility: Facilities;
  spinnerTableFlag = false;
  displaySuccessModal = false;
  showLoadingButtonSubmit = false;
  successContent: string;
  displayFailureNotification = false;
  errorMessage: string;
  stationList: any = [];

  constructor(
    private translateService: TranslateService,
    private sortByPipe: SortByPipe,
    private commonService: CommonService,
    private printerConfigService: PrinterConfigService,
    private formBuilder: FormBuilder,
    // private ltlSvc: LtlService,
    private loadingSvc: IsLoadingService,
    public paginationSortingService: PaginationSortingService
  ) {
    this.searchPopupFormGroup = this.formBuilder.group({
      printerReq: ['', Validators.required]
    });
    this.translateService.onDefaultLangChange.subscribe(lang => {
      this.errorMessage = '';
      this.successContent = '';
    });
  }

  ngOnInit(): void {
    /** Table initialization */
    this.customers = this.commonService.getSelectedCustomer();
    this.businessUnit = this.commonService.getSelectedBusinessUnit();
    this.facility = this.commonService.getSelectedFacility();

    if (this.facility) {
      this.printerConfigService.getPrinterConfigDetails(this.customers.customerId.toString(),this.facility.facilityID.toString(),
        null, null, null, 0, 100, null )
      .subscribe(async res => {
        this.loadingSvc.add();
        await res;
        if (res.success) {
          this.stationList = res.printerConfigs
            .map(item => item.requestor)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.stationList = this.sortByPipe.transform(
            this.stationList,
            true,
            'asc'
          );
          this.stationList.length == 1 ? this.searchPopupFormGroup.controls['printerReq'].setValue(this.stationList[0]) : false;
          this.loadingSvc.remove();
        }
      });
    }

  }

  valueNotNullEmptyCheck(formValue) {
    if (formValue !== undefined && formValue !== '' && formValue !== null) {
      return true;
    } else {
      return false;
    }
  }

  get printerReq() {
    return this.searchPopupFormGroup.get('printerReq') as FormControl;
  }

  onSubmit() {
    if (!this.printerReq.valid) {
      this.printerReq.markAsTouched(); 
    } else {
      this.printRequestor.emit(this.printerReq.value);
      this.onClose('close');
    }
  }

  // clearData() {
  //   this.searchPopupFormGroup.reset();
  //   this.searchPopupFormGroup.get('printerReq').setValue('');
  // }

  onClose(eventAction) {
    if (eventAction === 'close') {
      this.closePopUpModal.emit(null);
    }
  }

  handleCloseEventforSuccess() {
    this.displaySuccessModal = false;
    this.onClose('close');
  }

  handleCloseErrorEvent() {
    this.displayFailureNotification = false;
  }

}